var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t("homepage_title"))+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t("homepage_description"))+" ")]),_c('SearchJobs')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }